import { Injectable } from '@angular/core';
import { DatasetInterface } from 'app/models/dataset.model';
import { Resource } from 'app/models/resource.model';
import { TriggerInterface } from 'app/models/trigger.model';
import { TimeslotInterface, TimeslotMinutesItemInterface } from 'app/modules/common/timeslot/timeslot.interface';
import { DataTransformAbstractPost } from 'app/modules/global/classes/data.transform.abstract.down';
import { FluidDatePipe } from 'app/modules/global/pipes/fluidDate.pipe';
import {
  TriggerContentsItemInterface,
  TriggerPeriodicalInterface,
  TriggerTimeInterface,
  TriggerTimeScheduleInterface,
} from '../../trigger.interface';

@Injectable({
  providedIn: 'root',
})
export class TriggerDataTransformPost extends DataTransformAbstractPost {
  constructor(protected _fluidDatePipe: FluidDatePipe) {
    super();
  }

  transform(trigger: TriggerInterface): TriggerInterface {
    if (trigger.startAt) {
      trigger.startAt = this.normalizeDate(trigger.startAt.toString());
    }
    if (trigger.endAt) {
      trigger.endAt = this.normalizeDate(trigger.endAt.toString());
    }
    trigger.contents = this.normalizeContents(trigger.contents);
    console.log('transform down trigger', trigger);
    return trigger;
  }

  protected normalizeContents(contents: TriggerContentsItemInterface[]): TriggerContentsItemInterface[] {
    if (!Array.isArray(contents)) {
      return contents;
    }
    contents.forEach((item: TriggerContentsItemInterface) => {
      this.normalizeTimeslots(item.timeslots);
      this.normalizePeriodical(item.periodical);
      this.normalizeBehaviorTime(item.time);

      if (Array.isArray(item.dcontents)) {
        item.dcontents = item.dcontents.map((dcontent) => {
          return <DatasetInterface>{ id: dcontent.id };
        });
      }

      if (Array.isArray(item.resources)) {
        item.resources = item.resources.map((resource) => {
          return <Resource>{ id: resource.id };
        });
      }

      console.log('normalizzing trigger contents', item);
    });
    return contents;
  }

  protected normalizePeriodical(periodical: TriggerPeriodicalInterface): TriggerPeriodicalInterface {
    if (periodical) {
      this.normalizePeriodicalTimes(periodical.times);
    }
    return periodical;
  }

  protected normalizeBehaviorTime(time: TriggerTimeInterface): TriggerTimeInterface {
    if (time) {
      this.normalizeBehaviorTimeSchedules(time.schedules);
    }
    return time;
  }

  protected normalizeBehaviorTimeSchedules(schedules: TriggerTimeScheduleInterface[]): TriggerTimeScheduleInterface[] {
    if (!Array.isArray(schedules)) {
      return schedules;
    }
    schedules.forEach((item: TriggerTimeScheduleInterface) => {
      item.time = this.normalizeTime(item.time.toString());
    });
    return schedules;
  }

  protected normalizePeriodicalTimes(times: TimeslotMinutesItemInterface[]): TimeslotMinutesItemInterface[] {
    if (!Array.isArray(times)) {
      return times;
    }
    times.forEach((item: TimeslotMinutesItemInterface) => {
      this.normalizeTimeslot(item.timeslots);
    });
    return times;
  }

  protected normalizeTimeslots(timeslots: TimeslotInterface[]): TimeslotInterface[] {
    if (!Array.isArray(timeslots)) {
      return timeslots;
    }
    timeslots.forEach((timeslot: TimeslotInterface) => {
      this.normalizeTimeslot(timeslot);
    });
    return timeslots;
  }

  protected normalizeTimeslot(timeslot: TimeslotInterface): TimeslotInterface {
    if (!timeslot) return timeslot;

    if (timeslot.from) {
      timeslot.from = this.normalizeTime(timeslot.from.toString());
    }
    if (timeslot.to) {
      timeslot.to = this.normalizeTime(timeslot.to.toString());
    }
    return timeslot;
  }
}
